export default __webpack_public_path__ + "8e94cc418c70740357941ff02a106538.png";